module.exports = __webpack_public_path__ + "static/2001-08-18_02.02.53-1-8b5c315edbdc4e387e2f35ff6f4fcd91.jpg";